import PropTypes from "prop-types";
import { Route } from "react-router-dom";

/**
 * A route that shows its page inside a layout. When the route's path
 * matches the URL, the `component` is rendered wrapped in the `layout`
 * (think: nav bar, sidebar, header around the page).
 *
 * Both the page and the layout receive the router props (`match`,
 * `location`, `history`) — the layout uses them to highlight the active
 * nav item, show breadcrumbs, etc.
 *
 * Usage: normally you won't use this directly. `renderWithLayout` in the
 * Managers bundle builds these for you.
 */
const RouteWithLayout = ({ component: Component, layout: Layout, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(matchProps) => {
        return (
          <Layout {...matchProps}>
            <Component {...matchProps} />
          </Layout>
        );
      }}
    />
  );
};

RouteWithLayout.propTypes = {
  component: PropTypes.elementType.isRequired,
  layout: PropTypes.elementType.isRequired,
};

export { RouteWithLayout };
